// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios';
import {_sign} from "./utils/sign"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MetaInfo from 'vue-meta-info'
import VueGtag from "vue-gtag";
import store from './store'

/* 路由 */
import router from './router'
import showdown from 'showdown'// 引入md文件
// 使用md文件
Vue.prototype.md2html = (md)=> {
  let converter = new showdown.Converter();
  let text = md.toString();
  let html = converter.makeHtml(text);
  return html
};
Vue.use(VueGtag, {
  config: { id: "G-7MM1YF30F8" }
}, router);

const http = axios.create({
  timeout: 1000 * 300,
  // baseURL:"http://192.168.1.74:1798",
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  },
})

http.interceptors.request.use((config) => {
  var version = "v1";
var accesskey_id = "100001";
var timestamp = Math.round(new Date().getTime() / 1000 - 5).toString();
  config.headers.version = version
  config.headers.accesskeyId = accesskey_id
  config.headers.timestamp = timestamp
  for (var pair of config. data.entries()){
    var jsonData = {};
    if (pair[0] != 'images')
    jsonData[pair[0]] = pair[1]
    }
    config.headers.signature = _sign(jsonData)
  return config
});

Vue.prototype.$axios= http;

Vue.use(ElementUI);
Vue.use(MetaInfo)

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});
// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

import i18n from '@/i18n/index'

new Vue({
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  render: h => h(App),
//添加到这里,这里的render-event和vue.config.js里面的renderAfterDocumentEvent配置名称一致
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js